import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import FeatureGates from '@atlassian/feature-gate-js-client';
import AdminTrialCart from './admin-trial-cart';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
const StatsigContainer = (props) => (_jsx(FeatureGatedAdminTrialCart, { ...props }));
const NonEnrolledCart = () => {
    useEffect(() => {
        FeatureGates.manuallyLogExperimentExposure('wac_cart_a-b_experiment');
    }, []);
    return _jsx(_Fragment, {});
};
const FeatureGatedAdminTrialCart = (props) => {
    const aaid = Cookies.get('__aid_user_id');
    if (!aaid || aaid === '') {
        return _jsx(_Fragment, {});
    }
    const enrolledAb = FeatureGates.getExperimentValue('wac_cart_a-b_experiment', 'treatment', 'non-enrolled', { fireExperimentExposure: false });
    if (enrolledAb === 'non-enrolled') {
        return _jsx(NonEnrolledCart, {});
    }
    return _jsx(AdminTrialCart, { ...props, enrolled: enrolledAb });
};
export default StatsigContainer;
//# sourceMappingURL=statsig-container.js.map